export default class ShipmentSearchColumns {

    securityId = '';
    mode = '';
    columns = [];



}
